import $ from 'jquery';

/**
 * Handling operation selector functionality for Uploads Bulk Operations
 *
 * Note: <select> element should be disabled unless at least one upload is checked.
 *       Submit button should be disabled unless operation is selected
 */
class EmailsBulkSelector {

  constructor() {
  }

  /**
   * Initializing fields, gathering refs to DOM elements
   */
  init() {
    this.$select_all = $('#emails-select-all');
    this.$emailIds = $('.email-id');

    this.updateUI();
  }

  /**
   * Setup events for <select> element and checkboxes
   */
  setupEvents() {
    let _this = this;

    this.$select_all.on('change ifChanged', function () {
      _this.$emailIds
        .prop('checked', $(this).is(':checked'))
        .iCheck('update');
      _this.updateUI();
    });

    this.$emailIds.on('change ifChanged', function () {
      $(this).iCheck('update');
      _this.updateUI();
    });

  }

  /**
   * Update UI elements according to current elements state
   */
  updateUI() {

    let checkedCount = this.$emailIds.filter(':checked').length;
    let isAllSelected = checkedCount === this.$emailIds.length;

    this.$select_all
      .prop('checked', isAllSelected)
      .iCheck('update');

  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new EmailsBulkSelector();
